import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../../utils';
import { Heading, Container, Row, Col, Text } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import CardComponent from '../CardComponent';

import style from './style.module.scss';
import textStyle from 'aplazame-design-system/src/scss/text.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import ContainerV2 from '../../componentsV2/Container';

const stagger = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.25, delayChildren: 0.8 },
    },
};

export default function CtaSection({
    title,
    titleTag,
    text,
    ctas,
    desktopCompact,
    colorScheme,
    style: aliasStyle,
}) {
    colorScheme = colorScheme?.toLowerCase();
    if (aliasStyle === 'Style B') {
        return (
            <section
                // className={
                //     hasColorScheme ? colorStyle[`bg--${colorScheme}`] : ''
                // }
                className={colorStyle[`bg--primary`]}
            >
                <ContainerV2 containerClassName={`${style.containerCpm}`}>
                    <motion.div
                        variants={stagger}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ amount: 'some' }}
                        className={style.wrapper}
                    >
                        <Heading
                            tag={titleTag}
                            framer={1}
                            className={['mb-5', style.heading].join(' ')}
                        >
                            {title}
                        </Heading>

                        <motion.div variants={fadeInUp}>
                            <Text tag="div" className={[style.text].join(' ')}>
                                {text}
                            </Text>
                        </motion.div>

                        <motion.div variants={fadeInUp}>
                            {ctas && ctas.length ? (
                                <ButtonComponent
                                    buttonClassName={style.button}
                                    blockMobile={true}
                                    button={ctas[0].button}
                                    dark={false}
                                />
                            ) : null}
                        </motion.div>
                    </motion.div>
                </ContainerV2>
            </section>
        );
    }

    const isSecondary = ctas.length === 2;
    const hasColorScheme = colorScheme && colorScheme !== 'none';

    return (
        <section
            className={hasColorScheme ? colorStyle[`bg--${colorScheme}`] : ''}
        >
            <Container
                pt={{
                    xs: 10,
                    lg: isSecondary && !desktopCompact ? 20 : 10,
                }}
                pb={{
                    xs: isSecondary && !desktopCompact ? 15 : 5,
                    lg: isSecondary && !desktopCompact ? 15 : 10,
                }}
            >
                <Row
                    className={`${style['card-row']} ${isSecondary && desktopCompact
                        ? style['card-row--secondary']
                        : ''
                        }`}
                >
                    <Col
                        col={{ lg: isSecondary && desktopCompact ? 4 : 8 }}
                        offset={{ lg: isSecondary && !desktopCompact ? 2 : 0 }}
                        className={
                            isSecondary && !desktopCompact
                                ? 'text-lg-center'
                                : ''
                        }
                        pb={{
                            xs: 10,
                            lg: isSecondary && !desktopCompact ? 10 : 20,
                        }}
                    >
                        <Heading
                            tag={titleTag}
                            className={[
                                isSecondary ? 'h2' : 'h1',
                                'mb-5',
                                isSecondary && desktopCompact
                                    ? ''
                                    : textStyle.gradual,
                                style.heading,
                                !hasColorScheme ||
                                    colorScheme === 'primarylight'
                                    ? style['heading--hasNotColorScheme']
                                    : '',
                                'font-weight-bold',
                            ].join(' ')}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                        <Text
                            tag="div"
                            className={`${hasColorScheme ? 'h4' : 'h3'} ${style.textDefault
                                }`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {text}
                        </Text>
                    </Col>
                    {isSecondary && desktopCompact ? null : <Col />}
                    {ctas.map((cta, i) => (
                        <Col
                            className={aliasStyle === 'Style C' ? style.mbC : ""}
                            key={i}
                            col={{
                                lg: isSecondary && !desktopCompact ? 5 : 4,
                                xxl: 4,
                            }}
                            offset={{
                                lg:
                                    !i && isSecondary && !desktopCompact
                                        ? 1
                                        : 0,
                                xxl:
                                    !i && isSecondary && !desktopCompact
                                        ? 2
                                        : 0,
                            }}
                            pb={{ xs: 5, lg: 10 }}
                            data-sal="slide-up"
                            data-sal-delay={`xs-none--lg-${i * 200}`}
                            style={{
                                '--sal-duration': `3000ms`,
                            }}
                        >
                            {cta.typeStyle = aliasStyle === 'Style C' ? true : false}
                            {cta.button && <CardComponent {...cta} />}
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
